export type AchievementCategory = 'reading' | 'social' | 'streak' | 'collection' | 'milestone' | 'awards';
export type AchievementTier = 'bronze' | 'silver' | 'gold' | 'platinum';

export interface Achievement {
  id: string;
  name: string;
  description: string;
  icon: string;
  category: AchievementCategory;
  tier: AchievementTier;
  xp_reward: number;
  unlock_criteria: Record<string, any>;
  is_hidden: boolean;
  sort_order: number;
  created_at: string;
}

export interface UserAchievement {
  id: string;
  user_id: string;
  achievement_id: string;
  unlocked_at: string;
  progress_data?: Record<string, any>;
  achievement?: Achievement;
}

export interface AchievementProgress {
  id: string;
  user_id: string;
  achievement_id: string;
  current_value: number;
  target_value: number;
  last_updated: string;
  achievement?: Achievement;
}

export interface AchievementStats {
  total_achievements: number;
  unlocked_count: number;
  completion_percent: number;
  total_xp_from_achievements: number;
  total_xp?: number;
  level?: number;
  level_title?: string;
}

export const tierColors: Record<AchievementTier, string> = {
  bronze: 'hsl(25, 60%, 50%)',
  silver: 'hsl(0, 0%, 70%)',
  gold: 'hsl(45, 100%, 50%)',
  platinum: 'hsl(200, 10%, 85%)',
};

export const categoryLabels: Record<AchievementCategory, string> = {
  reading: 'Reading',
  social: 'Social',
  streak: 'Streak',
  collection: 'Collection',
  milestone: 'Milestone',
  awards: 'Awards',
};
